import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { StackedBarChart, DashboardGraph } from 'graph'
import { useGraphFetch, constants } from '../module'
import { useSelectedFleetIds } from 'features/settings'
import { v4 as uuid } from 'uuid'

const Graph = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const selectedFleetIds = useSelectedFleetIds()

  const { loading, error, data } = useGraphFetch()
  const path = '/reports/vehicle-servicing'

  useEffect(() => {
    console.log('[Service Tracking Graph] data: ', data)
    // eslint-disable-next-line
  }, [])

  const onClick = (key, value, booked) => {
    console.log('createGraphNodeClicker', { key, value, booked })
    if (key && value) {
      dispatch({ type: 'reportVehicleServicing_set_dashboard_filter', payload: true })
      navigate(`${path}?${key}=${value}&booked=${booked ? 'Yes' : 'No'}`)

    } else {
      navigate(`${path}?overdue=true&booked=${booked ? 'Yes' : 'No'}`)
    }
  }

  const onRefresh = () => {
    dispatch({
      type: constants.REQUEST_DATA,
      payload: null,
      options: { queryParams: { FleetId: selectedFleetIds.join() }, requestId: uuid() }
    })
  }

  return (
    <DashboardGraph
      title="Service Tracking"
      to={path}
      loading={loading}
      error={error}
      onRefresh={onRefresh}
      data={data}>
      {data && (
        <StackedBarChart
          data={data}
          showHealthAndSafetyDisclaimer
          noDataMessage="Our current data shows that you have no servicing requirements in the next 6 months."
          onClick={onClick}/>
      )}
    </DashboardGraph>
  )
}

export default Graph
